import React, { memo } from 'react'
import { string, func, shape } from 'prop-types'
import { Button } from '@gympass/yoga'

import SearchButtonShadown, { ButtonText } from './SearchInArea.style'

function SearchInArea({ displayText, onSearch, theme }) {
  return (
    <SearchButtonShadown>
      <Button inverted onClick={onSearch}>
        <ButtonText color={theme.buttonText.color}>{displayText}</ButtonText>
      </Button>
    </SearchButtonShadown>
  )
}

SearchInArea.propTypes = {
  displayText: string.isRequired,
  onSearch: func.isRequired,
  theme: shape({
    buttonText: shape({
      color: string,
    }),
  }),
}

SearchInArea.defaultProps = {
  theme: {
    buttonText: {
      color: '',
    },
  },
}

export default memo(SearchInArea)
